import axiosVApi from "../axiovishwam";
import {
  getReduxCompany,
  getStoredUser,
  getStoredCompany,
} from "../../helper/sessionHelper";
const user = getStoredUser();

const getDepartmentList = async () => {
  try {
    const response = await axiosVApi.post(`/Department/GetDepartmentDropdown`);
    return response?.data;
  } catch (error) {
    console.log("Error getDepartmentList===>:", error);
    return error?.response?.data;
  }
};

const getDepartmentDropdown = async (companyId) => {
  try {
    // const response = await axiosVApi.get(
    //   `/Department/GetDepartmentList/${companyId}`
    // );
    const response = await axiosVApi.get(
      `/Department/GetDepartmentList/${getStoredCompany()?.companyId || 0}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getDepartmentDropdown===>:", error);
    return error?.response?.data;
  }
};

const getUserList = async () => {
  try {
    const response = await axiosVApi.post(`User/GetUserDropdown`, {});
    return response?.data;
  } catch (error) {
    console.log("Error getUserList===>:", error);
    return error?.response?.data;
  }
};

const getProjectDropdown = async () => {
  try {
    const response = await axiosVApi.post(`Project/GetProjectDropdown`);
    return response?.data;
  } catch (error) {
    console.error("Error getProjectDropdown===>:", error);
    return error?.response?.data;
  }
};

const getProjectList = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosVApi.post(`Project/GetProjectList`, body);
    return response?.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    return error?.response?.data;
  }
};

const getProjectByUserId = async (userId, body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosVApi.post(
      `Project/GetProjectByUserId/${userId}`,
      body
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    return error?.response?.data;
  }
};

const getCompanyDropdown = async () => {
  try {
    const response = await axiosVApi.get(`Company/GetCompanyDropdown`);
    return response?.data;
  } catch (error) {
    console.log("Error getCompanyDropdown===>:", error);
    return error?.response?.data;
  }
};

const getLocationDropdown = async () => {
  try {
    const response = await axiosVApi.get(`Location/GetLocationDropdown`);
    return response?.data;
  } catch (error) {
    console.log("Error getLocationDropdown===>:", error);
    return error?.response?.data;
  }
};

const getVendorList = async (companyId) => {
  try {
    //const response = await axiosVApi.get(`Vendor/List/${companyId}`);
    let body = {
      projectId: 0,
      vendorTypeId: 0,
      companyId: getStoredCompany()?.companyId || 0, //user?.companyId || 0,
    };
    const response = await axiosVApi.post(`Vendor/List`, body);
    return response?.data;
  } catch (error) {
    console.log("Error getVendorList===>:", error);
    return error?.response?.data;
  }
};

const getUserDrodpownByDepartmentd = async (departmentId, companyId) => {
  try {
    const response = await axiosVApi.get(
      `User/GetUserDropdownByDepartmentId/${departmentId}/${companyId}`
    );
    // const response = await axiosVApi.get(
    //   `User/GetUserDropdownByDepartmentId/${departmentId}`
    // );
    return response?.data;
  } catch (error) {
    console.log("Error getUserDrodpownByDepartmentd===>:", error);
    return error?.response?.data;
  }
};

const getDepartmentDropdownForWorkFlow = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;

    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosVApi.post(
      `Department/GetDepartmentDropdownForWorkFlow`,
      body
    );
    return response?.data;
  } catch (error) {
    console.error("Error GetDepartmentDropdownForWorkFlow===>:", error);
    return error?.response?.data;
  }
};

const getWorkflowCategories = async (body) => {
  try {
    //body.companyId = user?.companyId || 0;
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosVApi.post(
      `Category/GetWorkflowCategories`,
      body
    );
    return response?.data;
  } catch (error) {
    console.error("Error getProjectDropdown===>:", error);
    return error?.response?.data;
  }
};

const getWorkFlowForApprovalForAsset = async (request) => {
  try {
    //request.companyId = user?.companyId || 0;
    request.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosVApi.post(
      `/WorkFlow/GetWorkFlowByCategory`,
      request
    );
    return response?.data?.data;
  } catch (error) {
    console.log("Error getWorkFlowForApprovalForAsset===>:", error);
    return error?.response?.data?.data;
  }
};

const GetVendorDropdown2 = async (searchText = "") => {
  try {
    if (searchText !== "") {
      const response = await axiosVApi.get(
        `Vendor/GetVendorDropdown2/${searchText}/${
          getStoredCompany()?.companyId || 0
        }`
      );
      return response?.data;
    }
    return [];
  } catch (error) {
    console.log("Error GetVendorDropdown2===>:", error);
    return [];
  }
};

const GetVendorDropdown = async () => {
  try {
    const response = await axiosVApi.get(`Vendor/GetVendorDropdown/`);
    return response?.data;
  } catch (error) {
    console.log("Error GetVendorDropdown===>:", error);
    return [];
  }
};

export const vishwamApi = {
  getDepartmentList,
  getUserList,
  getProjectDropdown,
  getCompanyDropdown,
  getLocationDropdown,
  getProjectList,
  getVendorList,
  getUserDrodpownByDepartmentd,
  getProjectByUserId,
  getDepartmentDropdownForWorkFlow,
  getWorkFlowForApprovalForAsset,
  getWorkflowCategories,
  getDepartmentDropdown,
  GetVendorDropdown2,
  GetVendorDropdown,
};
